/**
 * 设置模块
 * @author fulh
 * @update 2015-07-10 11:40:25
 */
$.module('MM.fixedbar.tool', function () {
  var MAIN = null,
    TMPL = MM.fixedbar.tmpl,
    SWITCH_KEY = 'MM_SWITCH_V2',
    DEFAULT_SWITCH = {
      gift: true,
      car: true,
      enterAnimation: true,
      chatAnimation: true,
      location: true,
    },
    SWICTH_LIST = {
      gift: {
        title: '礼物特效',
        type: 'user',
        desc: '关闭礼物动画特效，可一定程度降低直播间卡顿现象',
        status: true,
        setter: function (key, status) {
          if (MM.live && MM.live.animate && !status) {
            MM.live.animate.stop(key);
          }
        },
      },
      car: {
        title: '座驾特效',
        type: 'user',
        desc: '关闭座驾动画特效，可一定程度降低直播间卡顿现象',
        status: true,
        setter: function (key, status) {
          if (MM.live && MM.live.animate && !status) {
            MM.live.animate.stop(key, status);
          }
        },
      },
      enterAnimation: {
        title: '进场特效',
        type: 'user',
        desc: '关闭进场特效，可一定程度降低直播间卡顿现象',
        status: true,
        setter: function (key, status) {},
      },
      chatAnimation: {
        title: '聊天气泡特效',
        type: 'user',
        desc: '关闭聊天气泡特效特效，可一定程度降低直播间卡顿现象',
        status: true,
        setter: function (key, status) {},
      },
    };

  var _config = {
    tabType: 'user',
    data: {},
  };

  function _show() {
    // SWICTH_LIST.enter.status = MM.user.isVip() && MM.user.getUserInfo().vip_hiding;
    _getSwitch();

    MAIN = MM.fixedbar.main;

    MAIN.initDialog(
      $.template(TMPL.tool, { switch_list: SWICTH_LIST }),
      true,
      'tool',
      true,
    );
    var $wrap = $('#j_fixedbar_tool');
    if (_config.tabType != 'user') {
      // star  family
      $wrap
        .find('.fixedbar-tool-hd')
        .html(MM.fixedbar.tmpl['tool_tab_' + _config.tabType]);
      $wrap
        .find('.fixedbar-tool-bd')
        .append(
          $.template(MM.fixedbar.tmpl['tool_tab_' + _config.tabType + '_bd'], {
            switch_list: SWICTH_LIST,
            data: _config.data,
          }),
        );
    }

    //MAIN.showDialog("tool");
    _registerEvents();
  }

  function _registerEvents() {
    $('#j_fixedbar_tool .tool-switch').click(function () {
      $(this).toggleClass('tool-switch-off');
      _setSwitch($(this).data('type'), !$(this).hasClass('tool-switch-off'));
    });

    $('#j_fixedbar_tool .fixedbar-tool-hd a')
      .click(function (e) {
        e.preventDefault();
        var type = $(this).data('type');
        $(this).addClass('on').siblings().removeClass('on');

        _track($(this).text());
        var $container = $('#j_fixedbar_tool_' + type).show();
        $container.siblings().hide();
      })
      .eq(0)
      .click();
  }

  function _track(action) {
    MM.common.track('边栏_设置', action);
  }

  /**
   * 设置开关
   * @param key
   * @private
   */
  function _setSwitch(key, status) {
    //DEFAULT_SWITCH[key] = !DEFAULT_SWITCH[key];
    MAIN.track('设置_' + key);

    MM.core.debug('设置', key, status);

    if (SWICTH_LIST[key]) {
      SWICTH_LIST[key].status = status;
      for (var item in DEFAULT_SWITCH) {
        if (SWICTH_LIST[item]) {
          DEFAULT_SWITCH[item] = SWICTH_LIST[item].status;
        }
      }

      if (SWICTH_LIST[key] && SWICTH_LIST[key].setter) {
        SWICTH_LIST[key].setter(key, SWICTH_LIST[key].status);
      }

      $.store.set(SWITCH_KEY, DEFAULT_SWITCH);
    }
  }

  function _getSwitch(key) {
    DEFAULT_SWITCH = $.extend(DEFAULT_SWITCH, $.store.get(SWITCH_KEY));

    for (var item in DEFAULT_SWITCH) {
      if (SWICTH_LIST[item]) {
        SWICTH_LIST[item].status = DEFAULT_SWITCH[item];
      }
    }
    if (key) {
      return SWICTH_LIST[key] && SWICTH_LIST[key].status;
    } else {
      return SWICTH_LIST;
    }
  }

  /**
   * 添加开关
   * @param key  SWITCH_EXTRA[]
   * @param setter function(key,status){}
   */
  function _addSwich(key, setting) {
    SWICTH_LIST[key] = setting;
  }

  function _initConfig(config) {
    _config = config;
  }

  return {
    show: _show,
    getSwitch: _getSwitch,
    addSwitch: _addSwich,
    initConfig: _initConfig,
  };
});
